import React from 'react';
import PropTypes from 'prop-types';
import { Helmet } from 'react-helmet';
import { graphql } from 'gatsby';

import BaseLayout from '../../layouts/BaseLayout';
import Hero from '../../partials/Hero';
import StaticFooter from '../../partials/footer/StaticFooter';
import FooterCTA from '../../partials/footer/FooterCTA';
import CustomerLogos from '../../partials/global/CustomerLogos';
import ProductOverview from '../../partials/product/ProductOverview';
import { Data } from '../../components';
import FreeSignupForm from '../../components/FreeSignupForm';

const SignUpLandingPage = ({
  data: {
    markdownRemark: {
      frontmatter: { seoTitle, description, hero },
    },
  },
  pageContext: { nodeType },
}) => (
  <BaseLayout noFooter headerProps={{ forceCTAContrast: true }}>
    <Helmet
      title={seoTitle}
      meta={[
        { name: 'description', content: description },
        { name: 'robots', content: 'noindex, follow' },
        { name: 'node-type', content: nodeType },
      ]}
    />
    <Hero className="u-gradient--green-teal" contrast={false} particles={false}>
      <div className="hero-content">
        <div className="container">
          <div className="row row--xlargeGutter@medium row--deepMatch u-flexMiddle">
            <div className="column-6@medium u-contrast u-textCenter u-textLeft@medium">
              <h1 className="hero-title u-textFluid--h2-h3">
                <Data>{hero.heading}</Data>
              </h1>
              <div className="hero-titleSub">
                <Data markdown>{hero.blurb}</Data>
              </div>
            </div>
            <div className="column-6@medium">
              <div id="form" className="hero-formWrapper">
                <FreeSignupForm />
              </div>
            </div>
          </div>
        </div>
      </div>
    </Hero>
    <CustomerLogos className="u-bgPanel" />
    <div className="container">
      <ProductOverview />
    </div>
    <FooterCTA />
    <StaticFooter />
  </BaseLayout>
);

SignUpLandingPage.propTypes = {
  data: PropTypes.object.isRequired,
  pageContext: PropTypes.object.isRequired,
};

export default SignUpLandingPage;

export const pageQuery = graphql`
  query SignUpLandingPageSingle($slug: String!) {
    markdownRemark(
      fields: { slug: { eq: $slug } }
      fileAbsolutePath: { regex: "/src/sign-up-landing-pages/" }
    ) {
      fileAbsolutePath
      frontmatter {
        seoTitle
        description
        slug
        hero {
          heading
          blurb
        }
      }
      fields {
        slug
      }
    }
  }
`;
